import React, { useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import '../../assets/styles/dropdown.css';


function FilterDropdown({ onChange }) {
    // State to manage the selected filter option
    const [selectedFilter, setSelectedFilter] = useState('');

    // Handle selection change
    const handleSelection = (e) => {
        const filter = e.target.value; // Get the selected filter value
        setSelectedFilter(filter); // Update state with selected filter
        onChange(filter); // Call the onChange function passed as a prop with the selected filter
    };

    return (
        // Full width form control for the dropdown
        <FormControl fullWidth>
            {/* Label for the dropdown */}
            <InputLabel shrink={Boolean(selectedFilter)}>Filter Steps</InputLabel>
            {/* Dropdown for selecting filter options */}
            <Select value={selectedFilter} onChange={handleSelection}>
                {/* Menu items for different filter options, filter display word and filter keyword we use to search through the step names */}
                <MenuItem value=""><em>All Protocol Steps</em></MenuItem>
                <MenuItem value="Baseline">Baseline Steps Only</MenuItem>
                <MenuItem value="Stim">Stim Steps Only</MenuItem>
                <MenuItem value="TETRAS">TETRAS Steps Only</MenuItem>
                <MenuItem value="ADL">BF-ADL Steps Only</MenuItem>
                <MenuItem value="Right">Right Arm Only</MenuItem>
                <MenuItem value="Left">Left Arm Only</MenuItem>
            </Select>
        </FormControl>
    );
}

export default FilterDropdown;

